import { render, staticRenderFns } from "./BasePerPageSelect.vue?vue&type=template&id=4253ed23&scoped=true"
import script from "./BasePerPageSelect.vue?vue&type=script&setup=true&lang=js"
export * from "./BasePerPageSelect.vue?vue&type=script&setup=true&lang=js"
import style0 from "./BasePerPageSelect.vue?vue&type=style&index=0&id=4253ed23&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4253ed23",
  null
  
)

export default component.exports